/**
 * @generated SignedSource<<23dee21a6180e64af7ead3296157e1c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_shipmentQuote$data = {
  readonly showQuoteAsPending: boolean | null;
  readonly " $fragmentType": "PdpSharedShippingInfoLink_shipmentQuote";
};
export type PdpSharedShippingInfoLink_shipmentQuote$key = {
  readonly " $data"?: PdpSharedShippingInfoLink_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "8fec3d0a66cf5b93f4e9409d01f51a92";

export default node;
